/**
 * Map-like tab interraction
 */

export default (() => {
  const regionMaps = document.querySelectorAll('[data-region-map]')

  if (!regionMaps.length) return

  const desktopStates = {
    all: { tx: '0%', ty: '2%', scale: 1.0, underlayOpacity: 0.0 },
    apac: { tx: '-18%', ty: '5%', scale: 1.42, underlayOpacity: 0.16 },
    europe: { tx: '7%', ty: '17%', scale: 1.88, underlayOpacity: 0.16 },
    americas: { tx: '27%', ty: '5%', scale: 1.42, underlayOpacity: 0.16 },
    africa: { tx: '6%', ty: '1%', scale: 1.62, underlayOpacity: 0.16 },
  }

  const mobileStates = {
    all: { tx: '2%', ty: '10%', scale: 1.0, underlayOpacity: 0.0 },
    apac: { tx: '-29%', ty: '12%', scale: 1.38, underlayOpacity: 0.15 },
    europe: { tx: '12%', ty: '24%', scale: 1.78, underlayOpacity: 0.15 },
    americas: { tx: '42%', ty: '12%', scale: 1.4, underlayOpacity: 0.15 },
    africa: { tx: '12%', ty: '10%', scale: 1.58, underlayOpacity: 0.15 },
  }

  const getStates = () =>
    window.matchMedia('(max-width: 767.98px)').matches
      ? mobileStates
      : desktopStates

  const applyStateToMap = (map, state) => {
    map.style.setProperty('--tx', state.tx)
    map.style.setProperty('--ty', state.ty)
    map.style.setProperty('--scale', state.scale)
  }

  const initRegionMap = (section) => {
    const tabs = Array.from(section.querySelectorAll('.region-map-tab'))
    const maps = Array.from(section.querySelectorAll('.region-map-image'))

    if (!tabs.length || !maps.length) return null

    let currentRegion = 'all'

    const syncTabs = (region) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.region === region
        tab.classList.toggle('is-active', isActive)
        tab.setAttribute('aria-selected', String(isActive))
        tab.setAttribute('tabindex', isActive ? '0' : '-1')
      })
    }

    const render = (region = currentRegion) => {
      const states = getStates()
      const state = states[region]

      if (!state) return

      maps.forEach((map) => {
        const isActive = map.dataset.map === region

        applyStateToMap(map, state)
        map.classList.remove('is-active', 'is-underlay')

        if (isActive) {
          map.classList.add('is-active')
          map.style.opacity = '1'
        } else {
          map.classList.add('is-underlay')
          map.style.opacity = String(state.underlayOpacity)
        }
      })

      currentRegion = region
      syncTabs(region)
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        render(tab.dataset.region)
      })

      tab.addEventListener('keydown', (event) => {
        const currentIndex = tabs.indexOf(tab)
        let targetIndex = null

        if (event.key === 'ArrowRight') {
          targetIndex = (currentIndex + 1) % tabs.length
        }

        if (event.key === 'ArrowLeft') {
          targetIndex = (currentIndex - 1 + tabs.length) % tabs.length
        }

        if (targetIndex === null) return

        event.preventDefault()
        tabs[targetIndex].focus()
        render(tabs[targetIndex].dataset.region)
      })
    })

    render(currentRegion)

    return {
      rerender() {
        render(currentRegion)
      },
    }
  }

  const instances = Array.from(regionMaps)
    .map((section) => initRegionMap(section))
    .filter(Boolean)

  let resizeTimer = null

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      instances.forEach((instance) => instance.rerender())
    }, 80)
  })
})()
